module.exports = __webpack_public_path__ + "img/cornea.0264757a.png";